import {atomicScopes} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'
import type {AtomicScopesPublicAPI} from '@wix/document-services-public-types'

export default function (): PublicModuleDeclaration<AtomicScopesPublicAPI> {
    return {
        initMethod: atomicScopes.initialize
    }
}
